import {Record} from 'immutable';

import {makeReducer, match} from 'web-app/util/redux';
import * as EmployeeActions from 'web-app/react/entities/employees/actions';

export interface AboutStateProps {
    readonly loading: boolean;
}

export class AboutState extends Record<AboutStateProps>({
    loading: false,
}) {}

export default makeReducer<AboutState>(
    [
        match(EmployeeActions.fetchEmployee, state =>
            state.merge({
                loading: true,
            }),
        ),
        match(EmployeeActions.fetchEmployeeSuccess, state =>
            state.merge({
                loading: true,
            }),
        ),
        match(EmployeeActions.fetchEmployeeFailed, state =>
            state.merge({
                loading: true,
            }),
        ),
    ],
    new AboutState(),
);
